module.exports = __webpack_public_path__ + "static/img/moose_pictgrid12_800x699.dd83767.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/moose_pictgrid12_800x699.jpg
// module id = NDBR
// module chunks = 0